module.exports = __webpack_public_path__ + "img/AvatarProfile.28895829.png";